<div class="bg-subscription-pay" style="width: 100%;">
  <header class="schoolm-header" style="width: 100%;">
    <div class="schoolm-header-content">
      <div class="logo">
        <img src="brand/logo.jpeg" alt="SchoolMatik Solutions" class="logo-min-image">
      </div>
    </div>
  </header>
  <div class="step-container">
    <div class="card-pay">
      <div class="modal" tabindex="-1" role="dialog" id="modErrPay" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <div class="text-danger text-center font-weight-bold">{{message}}</div>
                @if(showAnticipationLnk){
              <div class="d-grid gap-2 col-6 mx-auto mt-2">
              
                <span class="text-success"> Vous pouvez payer la facture à l'avance en cliquant <a
                    routerLink="/school/payment/anticipation/{{idSchool}}/{{idStudent}}"
                    class="text-decoration-underline" data-bs-dismiss="modal">ici</a></span>
                
              </div>
              }
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
      @if (isBill) {
      <div id="bill-page" class="payment-page mt-3">
        <form [formGroup]="formBill">
          <div class="row justify-content-center">
            <img src="images/schoolmatik.jpeg" class="img-fluid col-2 mb-3">

          </div>
          @if (!isQrCode) {
          <div class="form-group form-floating">
            <select formControlName="school" name="school" class="ml-2 mr-2 mt-2 form-select">
              <option value="" selected>Choisir un établissement</option>
              @for (school of schools; track school) {
              <option value="{{school.id}}">{{school.name}}</option>
              }
            </select>
            <label>Choisir un établissement</label>
          </div>
          }
          @if (isQrCode) {
          <input type="hidden" formControlName="school" name="school" value="{{qrSchool?.id}}" />
          }
          @if (isQrCode) {
          <div class="form-group form-floating">
            <input value="{{qrSchool?.name}}" class="ml-2 mr-2 mt-2 form-control" id="schoolName" [disabled]="true">
            <label for="schoolName">Nom de l'établissement</label>
          </div>
          }
          <div class="form-group form-floating">
            <input type="text" class="ml-2 mr-2 mt-2 form-control" placeholder="Entrer le code l'élève"
              formControlName="idStudent" id="idStudent">
            <label for="idStudent">Entrer le code compta de l'élève</label>
          </div>
          <div class="d-grid gap-2 col-6 mx-auto mt-2">
            <button class="btn btn-success" (click)="findBill()" [disabled]="!formBill.valid">Chercher</button>
          </div>
        </form>
      </div>
      }
      @if (isPayment) {
      <div>
        <div id="payment-page" class="payment-page">
          <h5 class="text-center fw-bold">Paiement scolarité</h5>
          @if(bills.length>1){
          <div class="mb-3">
            <div for="billSelect" class="form-label">Plusieurs factures trouvées, veuillez choisir celle à payer</div>
            @for (b of bills; track b) {
            <input value="{{b.id}}" class="me-3" type="radio" name="billSelect" (click)="onSelectBill(b)" /><span
              [ngClass]="bill.id ==b.id? 'bg-success text-white rounded p-3' : ''">{{b.studentName}} - {{b.amount}}
              {{b.currency?.currencyCode}} <br /></span>
            }
          </div>
          }
          @if(selectedBill){

          <div class="mb-3">
            <label for="merchantName" class="form-label">Nom établissement: <span
                class="fw-bold">{{bill.school?.name}}</span></label>
          </div>
          <div class="mb-3">
            <label for="studentName" class="form-label">Nom de l'élève: <span
                class="fw-bold">{{bill.studentName}}</span></label>
          </div>
          <div class="mb-3">
            <label for="amount" class="form-label ">Montant :<span class="fw-bold">{{bill.amount}}
                {{bill.currency?.currencyCode}}</span></label>
          </div>
          @if(fees>0){
          <div class="mb-3">
            <label class="form-label">Frais de service :<span class="fw-bold">{{fees}}
                {{bill.currency?.currencyCode}}</span></label>
          </div>
          }
          @if(taxe>0){
          <div class="mb-3">
            <label class="form-label">Taxe :<span class="fw-bold">{{taxe}}
                {{bill.currency?.currencyCode}}</span></label>
          </div>
          }
          <div class="payment-header">
            <h3></h3>
            <p>Veuillez choisir votre moyen de paiement</p>
             @if (isWallet) {
            <p>Et Renseigner votre numero de téléphone</p>
             }
          </div>
          <div class="row justify-content-center gap-method">
            @for( p of paymentMeans; track $index){
               <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2"
              [attr.data-method]="p.code" style="width: auto;" (click)="onSelectPaymentMethod(p)">
              <img class="mt-4 img-fluid justify-content-center" src="{{p.logo}}" alt="{{p.label}}" width="50">
              <p class="mt-1  ml-3">{{p.label}}</p>
            </div>
            }
          </div>
          }
          <form [formGroup]="formPay">
            <div class="row justify-content-center">
              <div class=" form form-group col-sm-5  mb-2">
                @if (isWallet) {
                <input type="tel" placeholder="Numero t&#233;l&#233;phone" class="form-control" formControlName="phone">
                }
              </div>
            </div>
          </form>
          @if (isValid()&&!processing) {
          <div class="d-grid gap-2 col-6 mx-auto">
            <button class="btn btn-primary" (click)="processPayment()">
              Valider</button>
          </div>
          }
        </div>
      </div>
      }
      @if (qrCode.length>0) {
      <div class="row justify-content-center">
        <div class="d-flex justify-content-center" style="width: 300;">Scannez et payez </div>
        <div class="d-flex justify-content-center">
          <div class="d-block">
            <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        </div>
      </div>
      }
    </div>
  </div>
</div>